import React from "react";

import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Input,
  Container,
  Row, FormText
} from "reactstrap";

import SelectListComponent from "../utils/selectList";

const AirlineWalletPanel = ({
  airlines,
  generateNotes,
  handleSelectChange,
  requesting,
  noteOptions,
  selectedGenerate,
  AirlineCode,
  componentErrorMessages,
  onSubmit,
  Amount,
  toggle,
  Comments,
  onGenerateValueChange,
  handleChange,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <Container>
        <Row>
        <Col xs="6" sm="2">
            <FormGroup className={"mb-0 " + (componentErrorMessages.AirlineCode ? 'has-danger' : '')}>
              <Label>Airline</Label>
              <SelectListComponent
              placeholder={'Select airline...'} 
              data={airlines} 
              valueKey='Id'
               textField='Name' 
               selectValue={AirlineCode} 
               onValueChange={(event) => { handleSelectChange(event, 'AirlineCode') }}
              // onValueChange={(payload) => handleSelectChange(payload, 'Id', 'AirlineCode')}
                />
              {componentErrorMessages.AirlineCode && <FormText color="danger"> {componentErrorMessages.AirlineCode}</FormText>}
            </FormGroup>
          </Col>
          <Col xs="6" sm="2">
            <FormGroup className={"mb-0 " + (componentErrorMessages.Amount ? 'has-danger' : '')}>
              <Label>Amount</Label>
              <Input type="number"  name="select" value={Amount} onChange={(event) => { handleChange(event, 'Amount') }}/>
             { componentErrorMessages.Amount && <FormText color="danger"> {componentErrorMessages.Amount }</FormText> }
            </FormGroup>
          </Col>
          <Col xs="6" sm="4">
            <FormGroup  className={"mb-0 " + (componentErrorMessages.Comments ? 'has-danger' : '')}>
              <Label>Comment</Label>
             <Input type="text" value={Comments} onChange={(event) => { handleChange(event, 'Comments') }}/>
             { componentErrorMessages.Comments && <FormText color="danger"> {componentErrorMessages.Comments }</FormText> }
            </FormGroup>
          </Col>
          <Col xs="6" sm="2">
            <FormGroup className={"mb-0 " + (componentErrorMessages.selectValue ? 'has-danger' : '')}>
              <Label>Generate</Label>
              <SelectListComponent
                placeholder={'Select note...'} 
                data={generateNotes}
                valueKey="value"
                textField="label"
                selectValue={selectedGenerate}
                // onValueChange={onGenerateValueChange}
                onValueChange={(event) => { handleSelectChange(event, 'selectedGenerate') }}
              />
           { componentErrorMessages.selectValue && <FormText color="danger"> {componentErrorMessages.selectValue }</FormText> }
            </FormGroup>
          </Col>

          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button className="btn-avi-primary"
            onSubmit={(e) => toggle(e, "modalSlideIn")}
             >
              Submit
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default AirlineWalletPanel;



// WEBPACK FOOTER //
// ./src/views/airline-wallet/wallets-panel.js